<script>

export default {
  name: 'DuzeltmeDetay',
  props:[
    "open",
    "data"
  ],
  data() {
    return {
        title:'',
        isLoading: false,
        rows: [],
    }
  },
  watch:{
    open(){
        this.rows = []
       
        this.title = `${this.data.user_name} > Ödeme Düzeltme Detay`
        this.loadItems()
    }
  },
  methods: {
  

    transaction_date(props){
      return this.formatDate(props,"DD.MM.YYYY HH:MM")
    },

  

    loadItems() {
        this.$http.post(`dealers/${this.data.user_id}/balances/logs`,  { transaction_id : this.data.id })
            .then(response =>  this.rows = response.data)
    },
  

    close(){
      this.$parent.$bvModal.hide('duzeltme_gecmisi')
    },


  },
};
</script>

<template>
  <b-modal id="duzeltme_gecmisi" size="xl" :title=title  no-close-on-backdrop hide-footer>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>İşlemi Yapan</th>
                  <th>İşlem Tarihi</th>
                  <th>Log</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,i) in rows" :key="i">
                  <td>{{ row.username }}</td>
                  <td>{{ transaction_date(row.created_at) }}</td>
                  <td>{{ row.content }}</td>
               </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</b-modal>
</template>